import{useEffect,useState}from'react'
import{supabase}from'../supabase'
export default function EventList({onNewEvent,onSelectEvent,orgId,plan}){
const[events,setEvents]=useState([])
const[loading,setLoading]=useState(true)
useEffect(()=>{fetchEvents()},[orgId])
async function fetchEvents(){
if(!orgId){setLoading(true);return}
    const{data,error}=await supabase.from('events').select('*').eq('org_id',orgId)
if(error){console.error(error)}else{setEvents(data)}
setLoading(false)}
if(loading)return<div className='page'>Loading...</div>
return(<div className='page'>
<div className='page-header'>
<h2 className='page-title'>Events</h2>
<button className='btn-primary' onClick={()=>plan==='free'&&events.length>=2?alert('Free plan is limited to 2 events. Upgrade to Pro for unlimited events.'):onNewEvent()}>+ New Event</button>
</div>
{events.length===0?<div className='empty-state'><p>No events yet.</p></div>:
<div className='event-list'>{events.map(event=>(
<div key={event.id} className='event-card' onClick={()=>onSelectEvent(event.id)}>
<div>
<div className='event-status'>{event.status}</div>
<div className='event-name'>{event.name}</div>
<div className='event-artist'>{event.artist_name}</div>
</div>
<div className='event-date'>{event.event_date}</div>
</div>))}</div>}
</div>)}